import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonialsData } from '../mockData';
import { Card, CardContent } from './ui/card';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Student Success Stories
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            Hear from students who transformed their musical dreams into reality
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8">
          {testimonialsData.map((testimonial) => (
            <Card 
              key={testimonial.id}
              className="bg-slate-900/80 border-indigo-500/30 hover:border-indigo-400/50 transition-all hover:shadow-xl hover:shadow-indigo-500/10"
            >
              <CardContent className="p-8">
                <div className="mb-4">
                  <Quote className="w-10 h-10 text-indigo-500/30" />
                </div>
                
                <p className="text-slate-300 leading-relaxed mb-6 text-lg">
                  "{testimonial.content}"
                </p>
                
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-semibold text-white">{testimonial.name}</p>
                    <p className="text-sm text-slate-400">{testimonial.role}</p>
                  </div>
                  <div className="flex gap-1">
                    {[...Array(testimonial.rating)].map((_, idx) => (
                      <Star key={idx} className="w-5 h-5 fill-indigo-400 text-indigo-400" />
                    ))}
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;